"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubDashboardFlow = void 0;
var react_1 = __importStar(require("react"));
var Sankey_1 = __importDefault(require("./Sankey"));
/**
 * Sankey visualization for dashboard stage flow.
 *
 * @param {WsAiHubDashboardFlowProps} props - Component props
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubDashboardFlow = function (props) {
    var stageCounts = props.stageCounts, useCases = props.useCases;
    // Stabilize the flowCounts array reference so Sankey's effect doesn't see
    // a "new" prop on every parent render, which would otherwise destroy and
    // recreate the Chart.js instance unnecessarily.
    var flowCounts = react_1.useMemo(function () { return [
        stageCounts.stage1,
        stageCounts.stage2,
        stageCounts.stage3,
        stageCounts.stage4,
        stageCounts.stage5,
        stageCounts.stage6,
        stageCounts.stage7,
    ]; }, [
        stageCounts.stage1,
        stageCounts.stage2,
        stageCounts.stage3,
        stageCounts.stage4,
        stageCounts.stage5,
        stageCounts.stage6,
        stageCounts.stage7,
    ]);
    var targetName = "Use Cases (" + useCases.length + ")";
    return (react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-flow" },
        react_1.default.createElement(Sankey_1.default, { targetName: targetName, flowCounts: flowCounts })));
};
exports.WsAiHubDashboardFlow = WsAiHubDashboardFlow;
